import Http from './../http';

const prefix = '/website/public-link';

export const enable = website =>
  Http.authApi().put(`${prefix}/enable/${website.encrypted_id}`, website);

export const disable = website =>
  Http.authApi().put(`${prefix}/disable/${website.encrypted_id}`, website);

export const get = website =>
  Http.authApi().get(`${prefix}/${website.encrypted_id}`, website);

export const save = data =>
  Http.authApi().post(`${prefix}/${data.website.encrypted_id}`, data);



// WEBPACK FOOTER //
// ./src/js/services/editor/publicLink.js